const waitForCartProvider = () =>
  new Promise(resolve => {
    const provider = document.querySelector('cart-provider');
    if (provider) return resolve(provider);

    const observer = new MutationObserver(() => {
      const found = document.querySelector('cart-provider');
      if (found) {
        observer.disconnect();
        resolve(found);
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  });

waitForCartProvider().then(provider => {
  provider.publish('cart:add-feature', { feature: 'drawer' });
});

const usedUpsellVariantIds = new Set();

const getNextUpsell = () => {
  const script = document.getElementById('cxo-upsell-products');
  if (!script) return null;

  try {
    const list = JSON.parse(script.textContent);
    const next = list.find(item => !usedUpsellVariantIds.has(item.id));
    if (next) usedUpsellVariantIds.add(next.id);
    return next || null;
  } catch {
    return null;
  }
};

const createUpsellHTML = (product) => {
  return `
    <div class="cxo-studio__cart-upsell-item shadow-1 fade-in">
      <div class="cxo-studio__cart-upsell-image">
        <img src="${product.image}" alt="${product.title}">
      </div>
      <div class="cxo-studio__cart-upsell-info">
        <p class="cxo-studio__cart-upsell-title">${product.title}</p>
        <div class="cxo-studio__cart-upsell-prices">
          <span class="price">${product.price}</span>
          ${product.compare_at_price ? `<span class="compare-at">${product.compare_at_price}</span>` : ''}
        </div>
      </div>
      <button 
        class="cxo-studio__cart-upsell-button js-upsell-add #button @display-style:gradient @size:h5 @block @shadow"
        data-variant-id="${product.id}">
        Add +
      </button>
    </div>
  `;
};

const fadeOutAndLoadNext = (card) => {
  card.classList.add('fade-out');
  setTimeout(() => {
    card.remove();
    const next = getNextUpsell();
    if (next) {
      const list = document.querySelector('.cxo-studio__cart-upsells-list');
      if (list) {
        list.insertAdjacentHTML('beforeend', createUpsellHTML(next));
      }
    }
  }, 300);
};

document.addEventListener('click', async (event) => {
  const btn = event.target.closest('.js-upsell-add');
  if (!btn) return;

  const card = btn.closest('.cxo-studio__cart-upsell-item');
  const variantId = btn.getAttribute('data-variant-id');
  const quantity = 1;

  btn.disabled = true;
  btn.classList.add('loading');
  btn.innerHTML = `<span class="spinner"></span>`;

  try {
    const provider = await waitForCartProvider();
    provider.publish('cart:add', {
      items: [{ id: Number(variantId), quantity }]
    });
    fadeOutAndLoadNext(card);
  } catch {
    btn.disabled = false;
    btn.classList.remove('loading');
    btn.innerHTML = `Add +`;
  }
});